module.exports = __webpack_public_path__ + "img/634.caf02bb5.jpg";